module.exports = __webpack_public_path__ + "static/img/Marina-de-Marseille.e8366ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marina-de-Marseille.jpg
// module id = 1als
// module chunks = 0